"use client";

import { useEffect } from "react";
import { BRAND_NAME } from "@/lib/brand";

const SITE = BRAND_NAME;

/** Keep the browser tab title in sync after client data resolves (e.g. localStorage). */
export function useDocumentTitle(title: string | undefined | null) {
  useEffect(() => {
    if (!title) return;
    document.title = title === SITE ? SITE : `${title} · ${SITE}`;
  }, [title]);
}
